import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import commonStyles from '../../common/common.module.css';
import style from './ghaPage.module.css';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, MenuItem, OutlinedInput, Select } from '@material-ui/core';

const styles = (theme: Theme) =>

  createStyles({
    wrapper: {
      border: '1px solid rgba(9, 43, 74, 1)',
      paddingTop: '25px',
      boxShadow: '2px 2px 5px rgb(0 0 0 / 35%)',
      borderRadius: '15px',
      position: 'relative',
      marginBottom: '30px',
      paddingBottom: '25px',
      backgroundColor: 'white',
    },
    PoD: {
      color: 'inherit',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    awbActionsList: {
      display: 'flex',
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-between'
    },
    green: {
      backgroundColor: 'green !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    red: {
      backgroundColor: 'red !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    materialIcon: {
      padding: '0px 6px 0px',
      fontSize: '20px',
    },
    specials: {
      display: 'flex',
      flexDirection: 'column',
    },
    gap4px: {
      gap: '4px',
    },
    header: {
      marginLeft: '5%',
      marginTop: '2%'
    },
    flexSpcl: {
      flexWrap: 'nowrap'
    },
    overrideBorder: {
      border: '1px solid var(--primaryblue)',
      width: '100px'  
    },
    '@media (max-width: 991px)': {
      flexSpcl: {
        flexWrap: 'wrap'
      },
    }
  });

interface CounterSelectModalProps {
  classes: any;
  closeDialog: Function;
  counters: Array<any>;
  counterId: number;
  selectCounter: (e: any) => void;
};


const counterSelectModal = (props: CounterSelectModalProps) => {

  const counters = props.counters.length ? props.counters.map((option: any, index: number) => {
    return (
      <MenuItem disabled={ option.id_user } key={ index } value={ option.id }>{ option.name }</MenuItem>
    )
  }) : [];
  
  return (
    <div className={ style.bkgOverlay }>
      <div className={ `${style.dialogContainer } ${style.counterContainer}` }>
        <h3 className={ `${commonStyles.header} ${props.classes.header}` }> </h3>
        <div className={ `${style.dialogTitle} ${commonStyles.mx4}` }>
          <span className={ `${style.name} ${commonStyles.ml0}` }><span className={ commonStyles.colorRed }>Error: </span>Counter Not Selected</span>
          <IconButton aria-label="Close" className={ style.close }>
            <CloseIcon color='primary' onClick={() => props.closeDialog(false)} />
          </IconButton>
        </div>
        <div className={ `${commonStyles.m4} ${commonStyles.pb0} ${style.counterModal}` }>
          You have not selected the counter that you are seated at. Please select below.
          <div className={ `${commonStyles.fvMiddle} ${commonStyles.mt4}` }>
            <label className={ commonStyles.pr3 }>Select Counter #:</label>
            <Select
              className={ props.classes.overrideBorder }
              onChange={ (event: any) => props.selectCounter(event) }
              value={ props.counterId }
              input={<OutlinedInput labelWidth={120} notched={false} />}
            >
              {counters}
            </Select>
          </div>
        </div>

      </div>

    </div>
  );
};

export default withStyles(styles)(counterSelectModal);